/**
 * 模块: 图例组件
 * 职责: 显示图表图例说明
 * 限制: 文件<280行
 */

import React from 'react';

const Legend: React.FC = () => {
  return (
    <div style={{ marginTop: 16, display: 'flex', gap: 24, justifyContent: 'center', flexWrap: 'wrap' }}>
      <div>
        <span style={{ 
          display: 'inline-block', 
          width: 30, 
          height: 16, 
          background: 'linear-gradient(to right, #e8e8e8, #4a5568)', 
          borderRadius: '4px',
          marginRight: 8,
          verticalAlign: 'middle'
        }}></span>
        <span>市场影响力（浅→深）</span>
      </div>
      <div>
        <span style={{ 
          display: 'inline-block', 
          width: 20, 
          height: 2, 
          backgroundColor: '#8b5a5a', 
          marginRight: 8, 
          verticalAlign: 'middle' 
        }}></span>
        <span>直接竞争</span>
      </div>
      <div>
        <span style={{ 
          display: 'inline-block', 
          width: 20, 
          height: 2, 
          backgroundColor: '#8b7a5a', 
          marginRight: 8, 
          verticalAlign: 'middle' 
        }}></span>
        <span>间接竞争</span>
      </div>
      <div>
        <span style={{ 
          display: 'inline-block', 
          width: 20, 
          height: 2, 
          backgroundColor: '#5a8b5a', 
          marginRight: 8, 
          verticalAlign: 'middle' 
        }}></span>
        <span>潜在竞争</span>
      </div>
    </div>
  );
};

export default Legend;

